import { render } from "./last-assessment-date.vue?vue&type=template&id=c477c422&scoped=true&ts=true"
import script from "./last-assessment-date.vue?vue&type=script&lang=ts"
export * from "./last-assessment-date.vue?vue&type=script&lang=ts"

import "./last-assessment-date.vue?vue&type=style&index=0&id=c477c422&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c477c422"]])

export default __exports__